module.exports = __webpack_public_path__ + "static/media/fundo-registar.04c86cfb.png";